import GraphicParentChildQuestion from './GraphicParentChildQuestion';

export default GraphicParentChildQuestion;
